<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Supplier
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-text-field
                name="companyName"
                label="Company Name"
                type="text"
                v-model="queryParams.companyName"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="supplierList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.companyName }}</td>
              <td>{{ props.item.address }}</td>
              <td>{{ props.item.phone }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.contactPerson }}</td>
              <td>{{ props.item.createdDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.createdBy }}</td>
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { supplierService } from "../../services/supplier-service";

export default {
  name: "SupplierList",

  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),

    showListLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Supplier",
        disabled: true
      }
    ],
    headers: [
      { text: "Company Name", value: "companyName" },
      { text: "Address", value: "address" },
      { text: "Phone No.", value: "phone" },
      { text: "Email", value: "email" },
      { text: "Contact Person", value: "contact_person" },
      { text: "Created Date", value: "createdDate" },
      { text: "Created By", value: "createdBy" },
      { text: "Action", value: "name", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "createdDate",
      totalItems: 0
    },
    supplierList: [],
    totalRows: 0,
    queryParams: {
      companyName: "",
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getSupplierList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.companyName) {
      this.queryParams.companyName = this.$route.query.companyName;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "suppliers",
        query: this.queryParams
      });
      this.getSupplierList();
    },
    getSupplierList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      supplierService
        .getSupplierList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.supplierList = res.data.supplierList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/supplier/new");
    },
    onEdit(supplier) {
      // go to details page
      this.$router.push("/supplier/" + supplier.id);
    },
  }
};
</script>